import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, Modal, Alert, Tab, Tabs, Spinner, OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import { FaPlus, FaSave, FaArrowLeft, FaRegTrashAlt, FaAngleDown, FaInfo, FaInfoCircle, FaRegCheckCircle, FaDownload, FaList, FaQuestionCircle} from 'react-icons/fa';
import 'react-dropdown-tree-select/dist/styles.css'
import { DatePicker, Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import C from '../lib/Config';
import { classifySaveUserCaseResponse, SaveOutcome } from '../lib/SaveUserCaseResponse';
import { fetchProtocolsByPrimarySite } from '../lib/PrimarySiteUtils';
import Crypt from '../lib/Crypt';
import MicButton from './voice/MicButton';
import { writeText, appendText } from './voice/voiceWrite';
import $ from 'jquery';

const dateFormat = 'DD/MM/yyyy';
export default class NewTreatmentPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProtocol: [], //added
            generatedScheduledArr: [],
            creationDateTmt: this.formatDateMMMDDYYY(new Date()),
            modifiedDateTmt: this.formatDateMMDDYY(new Date()),
            context: this,
            redirectCasePage: false,
            caseStatus: '',
            isCycleDelay: false,
            cancerSiteArr: [],
            protocolArr: [],
            scheduleMstArr: [],
            patientId:this.props.patientId,
            registrationDate: '',
            caseNo: '',
            firstName: '',
            middleName: '',
            lastName: '',
            emailId: '',
            dob: '',
            patientAge: '',
            genderName: '',
            country: { countryId: null, countryCode: '', countryName: '' },
            phoneNumber1: '',
            doctorId: '',
            doctorName: '',
            instituteDto: { instituteId: null, instituteName: '' },
            height: '',
            weight: '',
            weightUnit:'',
            weightUnitId:'',
            weightShow:'',
            patientComorbidities: '',
            patientAllergies: '',
            otherComorbidities: '',
            allergies: '',
            anyOngoingTreatment: '',
            canSiteIdIAD: '',
            canSiteNameIAD: [],
            prevCanSiteIdIAD: '',
            prevCanSiteNameIAD: [],
            pathologyIdIAD: '',
            pathologyIAD: [],
            limbLossIdIAD: '',
            limbLossNameIAD: [],
            mutationIdIA: '',
            mutationNameIA: [],
            patientIniAssessmentDt: this.formatDateMMMDDYYY(new Date()),
            patientIniAssessmentId: '',
            doctorObservation: '',
            doctorPrescription: '',
            patTreatPlanIdTmt: this.props.patTreatPlanId,
            regProtocolIdTmt: '',
            regProtocolNameTmt: '',
            fnRiskTmt: '',
            antiemeticRiskLevel: '',
            scheduleIdTmt: '',
            scheduleNameTmt: '',
            scheduleDaysTmt: '',
            treatmentDaysTmt: '',
            multiDayCycleTmt: false,
            protocolTypeTmt: '',
            creationDateTmt: this.formatDateMMMDDYYY(new Date()),
            intentTmt: '',
            intentSummary: '',
            adjuvantTmt: '',
            adjuvantSummary: '',
            treatmentPlanTmt: '',
            additionalConditions: '',
            waiverComments: '',
            consentReceived: '',
            assesFNRiskFlag:'N',
            gcsfMedicinePC:'',
            chemoPhaseRegimenTmt: '',
            cyclesPlannedTmt: '',
            chemoStartDtTmt: '',
            patChemoSittingIdPC: '',
            cascadeChangePC: '',
            chemoCycleNumberPC: '',
            chemoDtPC: '',
            chemoPlannedDtPC: '',
            delayPC: '',
            delayCommentsPC: '',
            reasonForChemoDtChangePC: '',
            treatmentGivenPC: '',
            updatedDatePC: '',
            createdByIdUserPC: '',
            upcomingChemoCycleNum: '',
            upcomingChemoDt: '',
            lastChemoCycleNumber: '',
            lastChemoCycleDate: '',
            appointmentId: '',
            creationDateFP: '',
            observe: '',
            prescription: '',
            generatedScheduledArr: [],
            waiverConsent: false,
            showHideDemo1: false,
            showHideGenerateButton: false,
            previewModal: false,
            canSitesArr: [],
            prevCanSitesArr: [],
            limbLossArr: [],
            mutationArr:[],
            initialAssesmentErrors: [],
            treatmentPlanErrors: [],
            patChemoSittingErrors: [],
            alertModalshow: false,
            treatmentPlanshow: false,
            followupshow: false,
            chemoshow: false,
            saveLoader: false,
            subErrorMsg: '',
            loaderModal: false,
            reportModal: false,
            reportMode: null,
            showConsent: false,
            showAssessFNRisk: false,
            showNewTreatment: false,
            showTerminateProtocol: false,
            showMultipleChemoPopup: false,
            showTreatmentList: false,
            selectedApptReportData: null,
            followupErrors: [],
            appointmentReports: [],
            patientChemoSittingDosageList: [],
            suggestiveTreatementArr: [],
            buttonEnabled: true,
            pathology: '',
            pathologyMstArr: [],
            cancerStage: '',
            cancerStageMstArr: [],
            alertDismissibleshow: false,
            alertDismissibleAllergiesShow: false,
            khoronaScore:'',
            followupAdverseEffectIdIAD: '',
            isChemoTreatmentRecommended:'',
            errorMsgChemoTreatRecommend:'',
            errorMsgAdverseChemoTermination:'',
            creatineClearance:'',
            boneMetasis:'',
            brainMets:'',
            isHospitalStaff: false,
            doctorLoggedIn:false,
            errorAlertshow: false,
            errorAlertclose: false,
            antiemeticRisks: '',
            boneMetasisDrug: '',
            antithromboticDrugs: '',
            postChemoDrugs: '',
            nurseInstructions: '',
            patientInstructions: '',
            pharmacyInstructions: '',
            premedications: '',
            antiallergicDrugs: '',
            consentAttachmentName: '',
            consentAttachmentData: '',
            isCurrentTreatmentTerminated:'',
            //terminatedTreatments:[],
            followupAdverseEffectArr: [],
            showFollowupList: false,
            showChemoList: false,
            patAllChemoSittings: [],
            followupReports: [],
            dosageFrequency: '',
            activeTreatment : 'Y',
            chemoCycleNumber: '',
            otherAllergies: '',  
            //planNo: '',
            planTime: '', 
            isRestrictedFieldsVisible: false,         
        };
        this.handleTreatPlanChange = this.handleTreatPlanChange.bind(this);
        this.applyProtocolSelection = this.applyProtocolSelection.bind(this);
        // Additional Conditions/ Risks is an uncontrolled textarea (defaultValue),
        // so voice dictation has to append through the DOM node itself — a
        // setState would update the payload but leave the visible text stale.
        this.additionalConditionsRef = React.createRef();

    }

    // Appends a dictated chunk to Additional Conditions/ Risks. writeText drives
    // the field's own onChange, so handleTreatPlanChange keeps
    // this.state.additionalConditions in sync for the save payload.
    appendAdditionalConditions = (text) => {
        const el = this.additionalConditionsRef.current;
        if (el) writeText(el, appendText(el.value, text));
    };
    
    getLoggedInUserDetails = () => {
        const userId = localStorage.getItem("userId");
        const instituteId = this.state.instituteDto?.instituteId;
    
        // Using same conditions as dashboard
        if (userId === '90' || instituteId === 30 || userId === '74' || instituteId === 22) {
            this.setState({ isRestrictedFieldsVisible: true });
        } else {
            this.setState({ isRestrictedFieldsVisible: false });
        }
    }

    setChemoDOB(date) {
        this.setState({ chemoStartDtTmt: date })
        this.setState({ showHideDemo1: false });
        if (!this.state.showHideGenerateButton) {
            this.setState({ showHideGenerateButton: !this.state.showHideGenerateButton });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        const patTreatPlanId = this.props.patTreatPlanId || this.state.patTreatPlanIdTmt;
        if (patTreatPlanId && patTreatPlanId !== this.state.patTreatPlanIdTmt) {
            this.setState({ patTreatPlanIdTmt: patTreatPlanId });
        }
        
        // Get patientDetails from localStorage FIRST (before any API calls)
        const patientDetails = localStorage.getItem('patientDetails');
        let patientId = this.state.patientId;
        if (patientDetails) {
            const { firstName, lastName, patientId: localPatientId } = JSON.parse(patientDetails);
            this.setState({ firstName, lastName, patientId: localPatientId });
            patientId = localPatientId; // Use the patientId from localStorage
        }
        
        // NOW call the API ONLY if patientId is valid
        if (patientId && patientId !== 'undefined') {
            this.getPatientCaseDetail(patientId);
        }
        this.getAllSchedule();
        // getAllProtocols is deliberately NOT called here — see
        // loadProtocolOptions. At mount there is no primary-site filter yet, so
        // fetching now would pull the whole unfiltered protocol list on every
        // Case Profile page open, and then throw it away.
        this.getLoggedInUserDetails();
    }
    componentDidUpdate(prevProps) {
        if (this.props.showNewTreatment && !prevProps.showNewTreatment) {
            this.resetSelectedProtocol();

            // Only for a NEW plan. Editing an existing one flips this same
            // prop, and there the protocol is already fixed — applying a
            // pre-select left over from an earlier "add" would overwrite the
            // saved regimen, and the dropdown is not even rendered (it is a
            // disabled field fed from regProtocolNameTmt), so there is nothing
            // to load either.
            if (this.props.patTreatPlanId == 0) {
                this.loadProtocolOptions();
                // Applied here rather than from a ref call in the parent: the
                // reset above runs on this same edge and clears
                // regProtocolIdTmt, so a pre-select made just after the
                // parent's setState would be wiped.
                if (this.props.preselectedProtocol) {
                    this.applyProtocolSelection(this.props.preselectedProtocol);
                }
            }
        }
    }//added
    
    getTreatmentPlanDetail(patTreatPlanId) {
        return fetch(C.getUrl() + '/userCase/getTreatmentPlanDetail?patTreatPlanId=' + patTreatPlanId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                const treatmentPlanData = JSON.parse(resObj.message);
                
                // // Update state with the plan number from response
                // if (treatmentPlanData.patTreatmentPlanDTO && treatmentPlanData.patTreatmentPlanDTO.planNo) {
                //     this.setState({
                //         planNo: treatmentPlanData.patTreatmentPlanDTO.planNo
                //     });
                // }
                
                this.setTreatmentPlan(treatmentPlanData);
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    setPatientAllergiePopup(allergies){
        this.setState({ alertDismissibleAllergiesShow: true });
        this.setState({ allergies: allergies });
    }
    setPatientComorbitiesPopup(comorbities){
        this.setState({ alertDismissibleAllergiesShow: true });
        this.setState({ otherComorbidities: comorbities });
    }

    setCaseDetail(caseDetail) {
        this.setState({ caseStatus: caseDetail.status })
        this.setPatientDetail(caseDetail.patientDetailsDto);
    }
    setPatientDetail(obj) {
        if (obj) {
            if (obj.patientAllergies) {
                var patientAllergies = [];
                obj.patientAllergies.forEach(function (obj) {
                    patientAllergies.push(obj.allergiesMstDTO.allergiesName);
                });
                this.setState({ patientAllergies: patientAllergies });
            }
            if(obj.allergies !== undefined && obj.allergies != ''){
                this.setState({ allergies: obj.allergies });
            }
            if(obj.otherComorbidities !== undefined && obj.otherComorbidities != ''){
                this.setState({ otherComorbidities: obj.otherComorbidities });
            }
            if(obj.otherAllergies !== undefined && obj.otherAllergies != ''){
                this.setState({ otherAllergies: obj.otherAllergies });
            }
            if(obj.onGoingTreatment !== undefined && obj.onGoingTreatment != ''){
                this.setState({ onGoingTreatment: obj.onGoingTreatment });
            }
            
        }
    }
    getPatientCaseDetail(patientId) {
        // Validate patientId before making API call
        if (!patientId || patientId === 'undefined' || patientId === undefined) {
            console.error("Patient ID is undefined or invalid");
            return;
        }
        
        return fetch(C.getUrl() + '/userCase/getPatientSummaryDetails?patientId=' + patientId)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            this.setCaseDetail(JSON.parse(resObj.message));
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }
    setTreatmentPlan(caseDetail) {
        if (caseDetail.patTreatmentPlanDTO) {
            let patTreatmentPlan = caseDetail.patTreatmentPlanDTO;
            if(patTreatmentPlan.consentAttachmentName){       
                this.setState({ consentAttachmentData: patTreatmentPlan.consentAttachmentData });  
                this.setState({ consentAttachmentName: patTreatmentPlan.consentAttachmentName });
            }
            if (patTreatmentPlan.patientTreatmentPlanId) {
                this.setState({ patTreatPlanIdTmt: patTreatmentPlan.patientTreatmentPlanId });
            }
            //         // Only set planNo if it exists in the response
            // if (patTreatmentPlan.planNo) {
            //     this.setState({ planNo: patTreatmentPlan.planNo });
            // } else {
            //     this.setState({ planNo: '' }); // Reset if no planNo exists
            // }
            if (patTreatmentPlan.protocolMstDTO && patTreatmentPlan.protocolMstDTO.protocolId !== 0) {
                this.setState({ regProtocolIdTmt: patTreatmentPlan.protocolMstDTO.protocolId });
                this.setState({ regProtocolNameTmt: patTreatmentPlan.protocolMstDTO.protocolName });
                this.setState({ fnRiskTmt: patTreatmentPlan.protocolMstDTO.fnRisk });
                this.setState({ antiemeticRiskLevel: patTreatmentPlan.protocolMstDTO.antiemeticRiskLevel });
                // Absent for a protocol with no schedule linked. Reachable since
                // such protocols became selectable, so a saved plan can now carry
                // one — scheduleMstDTO on the next line was already guarded.
                this.setState({ dosageFrequency : patTreatmentPlan.protocolMstDTO.dosageFrequency
                    ? patTreatmentPlan.protocolMstDTO.dosageFrequency.scheduleName
                    : ''});
            }
            if (patTreatmentPlan.scheduleMstDTO && patTreatmentPlan.scheduleMstDTO.scheduleId !== 0) {
                this.setState({ scheduleIdTmt: patTreatmentPlan.scheduleMstDTO.scheduleId });
                this.setState({ scheduleNameTmt: patTreatmentPlan.scheduleMstDTO.scheduleName });
                this.setState({ scheduleDaysTmt: patTreatmentPlan.scheduleMstDTO.scheduleDays });
            }
            if (patTreatmentPlan.creationDate) {
                this.setState({ creationDateTmt: this.formatDateMMMDDYYY(patTreatmentPlan.creationDate) });
                this.setState({ modifiedDateTmt: this.formatDateMMDDYY(patTreatmentPlan.creationDate) });
            }
            if (patTreatmentPlan.intent) {
                this.setState({ intentTmt: patTreatmentPlan.intent });
                this.setState({ intentSummary: patTreatmentPlan.intent === 'C' ? 'Curative' : 'Palliative' });
            }
            if (patTreatmentPlan.adjuvant) {
                this.setState({ adjuvantTmt: patTreatmentPlan.adjuvant });
                this.setState({ adjuvantSummary: patTreatmentPlan.adjuvant === 'N' ? 'New' : 'After' });
            }
            // if (patTreatmentPlan.planNo) {
            //     this.setState({ planNo: patTreatmentPlan.planNo });
            // }
            if (patTreatmentPlan.planTime) {
                this.setState({ planTime: patTreatmentPlan.planTime });
            }
            this.setState({ treatmentPlanTmt: patTreatmentPlan.treatmentPlan });
            this.setState({ additionalConditions: patTreatmentPlan.additionalConditions });
            this.setState({ waiverComments: patTreatmentPlan.waiveOffConsent });
            this.setState({ consentReceived: patTreatmentPlan.consentReceived });
            if(patTreatmentPlan.consentReceived == 'Y'){
                this.setState({ alertDismissibleshow: false });
            }else{
                this.setState({ alertDismissibleshow: true });
            }
            this.setState({ chemoPhaseRegimenTmt: patTreatmentPlan.chemoPhaseRegimen });
            this.setState({ cyclesPlannedTmt: patTreatmentPlan.cyclesPlanned });
            this.setState({ chemoStartDtTmt: new Date(patTreatmentPlan.chemoStartDt) });
            if (patTreatmentPlan.protocolMstDTO) {
                console.log('[loadPlan] protocolMstDTO multiDayCycle:', patTreatmentPlan.protocolMstDTO.multiDayCycle, '| treatmentDays:', patTreatmentPlan.protocolMstDTO.treatmentDays, '| chemoTypeId:', patTreatmentPlan.protocolMstDTO.chemoTypeId);
                this.setState({
                    treatmentDaysTmt: patTreatmentPlan.protocolMstDTO.treatmentDays || '',
                    multiDayCycleTmt: patTreatmentPlan.protocolMstDTO.multiDayCycle || false,
                    protocolTypeTmt: patTreatmentPlan.protocolMstDTO.chemoTypeId || '',
                });
            }
            if (patTreatmentPlan.patientChemoScheduleDTOList && patTreatmentPlan.patientChemoScheduleDTOList.length !== 0) {
                let generatedScheduledArr = [];
                patTreatmentPlan.patientChemoScheduleDTOList.forEach(obj => {
                    let data = {
                        scheduleNum: obj.chemoCycleNumber,
                        treatmentDayNumber: obj.treatmentDayNumber || 1,
                        scheduledDate: obj.chemoDt
                    }
                    generatedScheduledArr.push(data);
                });
                console.log('[loadPlan] schedule items (' + generatedScheduledArr.length + '):', generatedScheduledArr.map(r => `C${r.scheduleNum} TD${r.treatmentDayNumber} ${r.scheduledDate}`));
                this.setState({ generatedScheduledArr: generatedScheduledArr });
            }
            this.setState({ activeTreatment : patTreatmentPlan.activeInd});

            const patientId = this.props.patientId || this.state.patientId;
            if (patientId) {
                this.getInitialAssessmentDetails(patientId);
            }
        }
    }

    getInitialAssessmentDetails(patientId) {
        if (!patientId || patientId === 'undefined') {
            console.error("getInitialAssessmentDetails called without a valid patientId");
            return;
        }
        return fetch(C.getUrl() + '/userCase/getInitialAssessmentDetails?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                if (res.message && res.message !== 'NO_DATA') {
                    this.setInitialAssesmentDetail(JSON.parse(res.message));
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    setInitialAssesmentDetail(caseDetail) {
        if (caseDetail.patInitiAssesmentDto) {
            let initialAssessment = caseDetail.patInitiAssesmentDto;
            this.setState({ patientIniAssessmentId: initialAssessment.patientIniAssessmentId });
            this.setState({ patientIniAssessmentDt: this.formatDateMMMDDYYY(initialAssessment.patientIniAssessmentDt) });
            this.setState({ doctorObservation: initialAssessment.doctorObservation });
            this.setState({ pathology: initialAssessment.pathologyText });
            if (initialAssessment.stageMasterDTO !== undefined && initialAssessment.stageMasterDTO.stageId !== '') {
                this.setState({ cancerStage: initialAssessment.stageMasterDTO.stageId });
            }
            this.setState({ boneMetasis: initialAssessment.boneMetasis });
            this.setState({ brainMets: initialAssessment.brainMets });
            if (caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList && caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList.size !== 0) {
                let patCancerSiteList = caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList;
                var selectedCancerSite = [];
                var selectedCancerSiteName = [];
                patCancerSiteList.map(function (d) {
                    selectedCancerSite.push({ id: d.cancerSiteMstDto.cancerSiteId, name: d.cancerSiteMstDto.cancerSiteName });
                    selectedCancerSiteName.push(d.cancerSiteMstDto.cancerSiteName);
                });
                this.setState({ canSiteIdIAD: selectedCancerSite });
                this.setState({ canSiteNameIAD: selectedCancerSiteName });
            }
            if (caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList && caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList.size !== 0) {
                let patPrevCancerSiteList = caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList;
                var selectedPrevCancerSite = [];
                var selectedPrevCancerSiteName = [];
                patPrevCancerSiteList.map(function (d) {
                    selectedPrevCancerSite.push({ id: d.cancerSiteMstDTO.cancerSiteId, name: d.cancerSiteMstDTO.cancerSiteName });
                    selectedPrevCancerSiteName.push(d.cancerSiteMstDTO.cancerSiteName);
                });
                this.setState({ prevCanSiteIdIAD: selectedPrevCancerSite });
                this.setState({ prevCanSiteNameIAD: selectedPrevCancerSiteName });
            }
            if (caseDetail.patInitiAssesmentDto.patientLimbLossDTOList && caseDetail.patInitiAssesmentDto.patientLimbLossDTOList.size !== 0) {
                let patLimbLossList = caseDetail.patInitiAssesmentDto.patientLimbLossDTOList;
                var selectedLimbLoss = [];
                var selectedLimbLossName = [];
                patLimbLossList.map(function (d) {
                    selectedLimbLoss.push({ id: d.limbLossMasterDTO.limbLossId, name: d.limbLossMasterDTO.limbLossName });
                    selectedLimbLossName.push(d.limbLossMasterDTO.limbLossId);
                });
                this.setState({ limbLossIdIAD: selectedLimbLoss });
                this.setState({ limbLossNameIAD: selectedLimbLossName });
            }
            if (caseDetail.patInitiAssesmentDto.patientMutationXrefList && caseDetail.patInitiAssesmentDto.patientMutationXrefList.size !== 0) {
                let patientMutationXrefList = caseDetail.patInitiAssesmentDto.patientMutationXrefList;
                var selectedMutationId = [];
                var selectedMutationName = [];
                patientMutationXrefList.map(function (d) {
                    selectedMutationId.push({ id: d.mutationMstDTO.mutationId, name: d.mutationMstDTO.mutationName });
                    selectedMutationName.push(d.mutationMstDTO.mutationName);
                });
                this.setState({ mutationIdIA: selectedMutationId });
                this.setState({ mutationNameIA: selectedMutationName });
            }
        }
    }

    formatDateMMDDYY(date) {
        if (date !== undefined && date !== "") {
            var dateTypeformate = (new Date(date)).toISOString().split('T')[0];
            return dateTypeformate;
        }
        return "";
    }

    hideComponent(name) {
        switch (name) {
            case "showHideDemo1":
                this.generateSchedule();
                this.setState({ showHideDemo1: true, showHideGenerateButton: !this.state.showHideGenerateButton });
                break;
            default:
                break;
        }
    }
    formatDateMMMDDYYY(date) {
        if (date !== undefined && date !== "") {
            var myDate = new Date(date);
            var month = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ][myDate.getMonth()];
            var str = month + " " + myDate.getDate() + ", " + myDate.getFullYear();
            return str;
        }
        return "";
    }
    
    generatePlanNumber(mrNo, currentDate) {
        const currentYear = currentDate.getFullYear().toString().slice(-2);
        const formattedMrNo = mrNo.toString().padStart(4, '0');
        const timestamp = Date.now().toString().slice(-2); // Use last 2 digits of timestamp
        const randomNum = Math.floor(Math.random() * 1000).toString().padStart(4, '0'); // Generate 4-digit random number
        return `CE-${formattedMrNo}-${randomNum}-${timestamp}-${currentYear}`;
    }

    submitTreateMentPlan(event) {
        let isThisValidForm = false;
        if (this.validateTreatmentPlan()) {
            isThisValidForm = true;
        }
        if (isThisValidForm) {
            let patChemoScheduleArr = [];
            if (this.state.generatedScheduledArr !== null && this.state.generatedScheduledArr.length !== 0) {
                this.state.generatedScheduledArr.forEach(function (obj) {
                    let data = {
                        chemoCycleNumber: obj.scheduleNum,
                        treatmentDayNumber: obj.treatmentDayNumber || 1,
                        chemoDt: obj.scheduledDate
                    }
                    patChemoScheduleArr.push(data);
                });
            }
              // Generate plan number
                const currentDate = new Date();
                const planNo = this.generatePlanNumber(
                    this.state.mrNo || '0000',
                    currentDate
                );
            let data = {
                status: 'T',
                patTreatmentPlanDTO: {
                    patientTreatmentPlanId: this.state.patTreatPlanIdTmt,
                    creationDate: this.state.modifiedDateTmt,
                    intent: this.state.intentTmt,
                    adjuvant: this.state.adjuvantTmt,
                    chemoStartDt: this.state.chemoStartDtTmt,
                    consentReceived: this.state.consentReceived,
                    additionalConditions : this.state.additionalConditions,
                    waiveOffConsent : this.state.waiverComments,
                    consentAttachmentData: this.state.consentAttachmentData,
                    consentAttachmentName: this.state.consentAttachmentName,
                    //planNo: planNo,
                    planTime: this.state.planTime,
                    patientDTO: {
                        patientID: this.props.patientId
                    },
                    protocolMstDTO: {
                        protocolId: this.state.regProtocolIdTmt,
                        protocolName: this.state.regProtocolNameTmt
                    },
                    treatmentPlan: this.state.treatmentPlanTmt,
                    scheduleMstDTO: {
                        scheduleId: this.state.scheduleIdTmt,
                        scheduleName: this.state.scheduleNameTmt
                    },
                    chemoPhaseRegimen: this.state.chemoPhaseRegimenTmt,
                    cyclesPlanned: this.state.cyclesPlannedTmt,
                    createdByIdUser: {
                        userId: this.props.doctorId
                    },
                    patientChemoScheduleDTOList: patChemoScheduleArr
                }
            }
            const userId = localStorage.getItem("userId");
            if (userId === '90' || userId === '74') {
                data.patTreatmentPlanDTO.planNo = planNo;
            }
            if(this.state.caseStatus == 'I'){
                this.setState({caseStatus : 'T'});
            }
            

           

            return fetch(C.getUrl() + '/userCase/saveUserCase', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                const result = classifySaveUserCaseResponse(res);
                if (result.outcome === SaveOutcome.SUCCESS) {
                    // 200 + subErrors means saved WITH warnings — the save
                    // succeeded, so run the success side-effects regardless.
                    this.setState({ subErrorMsg: result.warnings ? result.warnings.join(' ') : '' });
                    this.setState({ saveLoader: true, treatmentPlanshow: true});
                    setTimeout(() => {
                        this.setState({ saveLoader: false, treatmentPlanshow: false })
                    }, 3000);
                    this.resetTreatmentPlanData();
                    this.props.treatmentPlanSavedSuccess(result.saved);
                    this.props.closeModal();
                    //window.location.reload(false);
                    //window.location.reload()
                } else {
                    // BLOCKED (451/403) or ERROR (400/unexpected) — surface the reason.
                    this.setState({ subErrorMsg: result.message });
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
        }
    }
    isValidFileType = (type) => {
        switch (type) {
            case 'image/png':
                return true;

            case 'image/jpeg':
                return true;

            case 'image/jpg':
                return true;

            default:
                return false;
        }
    }
    
    showAlertDismissible = () => {
        this.setState({ alertDismissibleshow: true });
    }

    getAllSchedule = async () => {
        fetch(C.getUrl() + '/schedule/getAllSchedule')
        .then(res => res.json())
        .then(res => {
            if (!this._isMounted) return;
            let data = JSON.parse(res.message);
            var arr = [];
            data.map((item, index) => {
                let jsonList = new Object();
                jsonList['key'] = Crypt.getUniqueKey(index);
                jsonList['id'] = item.selectionId;
                jsonList['label'] = item.selectionValue;
                jsonList['scheduleDays'] = item.additionalValue;
                arr.push(jsonList);
            });
            this.setState({ scheduleMstArr: arr });
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    // Fills the Regimen Planned dropdown, filtered to the protocols indicated
    // for this diagnosis's primary sites.
    //
    // Called on the showNewTreatment edge rather than at mount, so the site
    // filter is known and the ~480-row unfiltered list is not pulled on every
    // Case Profile open. In the normal path the protocol picker has just
    // fetched exactly this list, so it arrives as a prop and costs no request
    // at all; only the "None of these" route (which widens to every protocol)
    // has to ask.
    loadProtocolOptions = () => {
        const toOptions = (protocols) => protocols.map((item, index) => ({
            key: Crypt.getUniqueKey(index),
            id: item.protocolId,
            label: item.protocolName,
        }));

        const prefetched = this.props.prefetchedProtocols;
        if (Array.isArray(prefetched) && prefetched.length > 0) {
            this.setState({ protocolArr: toOptions(prefetched) });
            return Promise.resolve();
        }

        return fetchProtocolsByPrimarySite(this.props.protocolFilterSiteIds)
            .then(protocols => {
                if (!this._isMounted) return;
                this.setState({ protocolArr: toOptions(protocols) });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    // Applies a protocol chosen outside this form (the Confirm New Treatment
    // Plan picker), as if the user had selected it in the dropdown.
    //
    // handleTreatPlanChange does the whole side-effect chain — schedule,
    // dosage frequency, plan-of-treatment text, treatment days — so it is
    // reused rather than duplicated. The name is then set explicitly: that
    // handler resolves it by scanning protocolArr, which is loaded async and
    // may not contain the row yet, and it leaves the name stale rather than
    // erroring when it misses.
    applyProtocolSelection(protocol) {
        if (!protocol || !protocol.protocolId) return Promise.resolve();

        const result = this.handleTreatPlanChange({
            target: { name: 'regProtocolIdTmt', value: protocol.protocolId },
        });

        this.setState({ regProtocolNameTmt: protocol.protocolName || '' });
        return Promise.resolve(result);
    }
    resetSelectedProtocol = () => {
        this.setState({ selectedProtocol: [] });
    }; //new function
    
    validateTreatmentPlan() {
        let formIsValid = true;
        let errors = {};
        if (this.state.intentTmt === null || this.state.intentTmt === '' || this.state.intentTmt === 'DEFAULT') {
            errors["intentTmt"] = "Please select Intent";
            formIsValid = false;
        }
        if (this.state.adjuvantTmt === null || this.state.adjuvantTmt === '' || this.state.adjuvantTmt === 'DEFAULT') {
            errors["adjuvantTmt"] = "Please select Adjuvant";
            formIsValid = false;
        }
        if (this.state.regProtocolIdTmt === null || this.state.regProtocolIdTmt === "") {
            errors["regProtocolIdTmt"] = "Please select Regimen Planned";
            formIsValid = false;
        }
        if (this.state.treatmentPlanTmt === null || this.state.treatmentPlanTmt === "") {
            errors["treatmentPlanTmt"] = "Please enter Plan of Treatment";
            formIsValid = false;
        }
        if (this.state.scheduleIdTmt === null || this.state.scheduleIdTmt === "") {
            errors["scheduleIdTmt"] = "Please select Schedule of the Protocol";
            formIsValid = false;
        }
        if (this.state.chemoPhaseRegimenTmt === null || this.state.chemoPhaseRegimenTmt === "") {
            errors["chemoPhaseRegimenTmt"] = "Please enter Chemotherapy Phase/ Regimen Due";
            formIsValid = false;
        }
        if (this.state.cyclesPlannedTmt === null || this.state.cyclesPlannedTmt === "") {
            errors["cyclesPlannedTmt"] = "Please enter Cycles Planned";
            formIsValid = false;
        }
        if (this.state.cyclesPlannedTmt !== null && this.state.cyclesPlannedTmt !== "" && Number(this.state.cyclesPlannedTmt) <= 0) {
            errors["cyclesPlannedTmt"] = "Cycles Planned must be greater than 0.";
            formIsValid = false;
        }
        if (this.state.chemoStartDtTmt === null || this.state.chemoStartDtTmt === "") {
            errors["chemoStartDtTmt"] = "Please enter 1st Chemo Cycle";
            formIsValid = false;
        }
        // if (this.state.isRestrictedFieldsVisible &&
        //     (this.state.patTreatPlanIdTmt == 0 || this.state.planNo)) {
        //     if (!this.state.planNo) {
        //         errors["planNo"] = "Please enter Plan No.";
        //         formIsValid = false;
        //     }
        // }
        this.setState({ treatmentPlanErrors: errors });
        return formIsValid;
    }
    addDays(forDate, days) {
        var newDate = new Date(forDate.getTime() + (days * 86400000));
        return newDate;
    }
    // Treatment days / cycle type, taken from the treatment response itself.
    //
    // This used to be a second unconditional call to getProtocolDetails, because
    // getProtocolDetailsForTreatment was believed not to return multiDayCycle or
    // treatmentDays. The backend says both have been in that projection for a
    // while (chemoTypeId was the only genuinely missing one, now added), so the
    // extra round-trip on every protocol selection is gone.
    //
    // The fallback stays only until that is confirmed against a real server: if
    // the fields really are absent, treatmentDaysTmt drives parseTreatmentDays
    // and generateSchedule, so getting it wrong lays out chemo cycles on the
    // wrong days rather than failing visibly. The warning below says which of
    // the two is true the first time a protocol is picked — once it never fires,
    // delete fetchTreatmentDaysForProtocol and this comment with it.
    applyTreatmentDays(resObj, protocolId) {
        if (resObj && resObj.treatmentDays !== undefined && resObj.multiDayCycle !== undefined) {
            this.setState({
                treatmentDaysTmt: resObj.treatmentDays || '',
                multiDayCycleTmt: resObj.multiDayCycle || false,
                protocolTypeTmt: resObj.chemoTypeId || '',
            });
            return Promise.resolve();
        }

        console.warn(
            '[applyTreatmentDays] getProtocolDetailsForTreatment did not return ' +
            'treatmentDays/multiDayCycle — falling back to getProtocolDetails. ' +
            'Report this to the backend team; the fallback is meant to be dead code.'
        );
        return this.fetchTreatmentDaysForProtocol(protocolId);
    }

    fetchTreatmentDaysForProtocol(protocolId) {
        return fetch(C.getUrl() + '/protocol/getProtocolDetails/' + protocolId)
            .then(res => res.json())
            .then(res => {
                const resObj = JSON.parse(res.message);
                console.log('[fetchTreatmentDaysForProtocol] multiDayCycle:', resObj.multiDayCycle, '| treatmentDays:', resObj.treatmentDays, '| chemoTypeId:', resObj.chemoTypeId);
                this.setState({
                    treatmentDaysTmt: resObj.treatmentDays || '',
                    multiDayCycleTmt: resObj.multiDayCycle || false,
                    protocolTypeTmt: resObj.chemoTypeId || '',
                });
            })
            .catch(err => console.log('[fetchTreatmentDaysForProtocol] Error:', err));
    }
    parseTreatmentDays(treatmentDays) {
        if (!treatmentDays || !treatmentDays.trim()) return [];
        const days = [];
        treatmentDays.split(',').forEach(part => {
            part = part.trim();
            if (part.includes('-')) {
                const [start, end] = part.split('-').map(Number);
                for (let d = start; d <= end; d++) days.push(d);
            } else {
                days.push(Number(part));
            }
        });
        return days.sort((a, b) => a - b);
    }
    handleTreatPlanChange(event,selectedOption) {   //added selectedOption in this function
        if (event.target.name === 'creationDateTmt') {
            this.setState({ creationDateTmt: event.target.value });
        }
        if (event.target.name === 'modifiedDateTmt') {
            this.setState({ modifiedDateTmt: event.target.value });
        }
        if (event.target.name === 'intentTmt') {
            this.setState({ intentTmt: event.target.value });
        }
        if (event.target.name === 'adjuvantTmt') {
            this.setState({ adjuvantTmt: event.target.value});
        }
        if (event.target.name === 'regProtocolIdTmt') {
            this.resetSelectedProtocol();
            this.setState({ regProtocolIdTmt: event.target.value });
            this.state.protocolArr.map((item, i) => {
                if(Number(item.id) === Number(event.target.value)){
                    this.setState({ regProtocolNameTmt:item.label})
                }
            });
            this.setState({ showHideDemo1: false });
            if (!this.state.showHideGenerateButton) {
                this.setState({ showHideGenerateButton: !this.state.showHideGenerateButton });
            }
            return fetch(C.getUrl() + '/protocol/getProtocolDetailsForTreatment/'+event.target.value)
            .then(res => res.json())
            .then(res => {
                let resObj = JSON.parse(res.message);

                // scheduleMstDTO and dosageFrequency are ABSENT (not zeroed) for a
                // protocol with no schedule linked. That was unreachable until the
                // primary-site picker started listing every protocol, so these reads
                // used to be safe and no longer are.
                //
                // The fields are CLEARED rather than left alone when absent: skipping
                // the assignment would leave the previously selected protocol's cycle
                // length in scheduleIdTmt, and Generate Schedule would silently lay
                // out this protocol's cycles at the wrong interval. Blank instead
                // makes checkMandatoryfieldGenerate stop the user with a message.
                const schedule = resObj.scheduleMstDTO;
                this.setState({
                    scheduleIdTmt: schedule ? schedule.scheduleId : '',
                    scheduleNameTmt: schedule ? schedule.scheduleName : '',
                    scheduleDaysTmt: schedule ? schedule.scheduleDays : '',
                    dosageFrequency: resObj.dosageFrequency ? resObj.dosageFrequency.scheduleName : '',
                    treatmentPlanTmt: resObj.chemoTreatment,
                });

                this.applyTreatmentDays(resObj, event.target.value);
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
        if (event.target.name === 'treatmentPlanTmt') {
            this.setState({ treatmentPlanTmt: event.target.value });
        }
        if (event.target.name === 'scheduleIdTmt') {
            if (!this.state.showHideGenerateButton) {
                this.setState({ showHideGenerateButton: !this.state.showHideGenerateButton });
            }
            this.setState({ showHideDemo1: false });
            this.setState({ scheduleIdTmt: event.target.value });
        }
        if (event.target.name === 'chemoPhaseRegimenTmt') {
            this.setState({ chemoPhaseRegimenTmt: event.target.value });
        }
        if (event.target.name === 'cyclesPlannedTmt') {
            if (Number(event.target.value) <= 0) {
                let errors = {};
                errors["cyclesPlannedTmt"] = "Cycles Planned must be greater than 0.";
                this.setState({ treatmentPlanErrors: errors });
            } else if (this.state.chemoCycleNumberPC !== 'undefined' && event.target.value < this.state.chemoCycleNumberPC) {
                let errors = {};
                errors["cyclesPlannedTmt"] = "Cycle planned cannot be less than chemo sitting.";
                this.setState({ treatmentPlanErrors: errors });
            } else {
                let errors = {};
                this.setState({ treatmentPlanErrors: errors });
            }
            this.setState({ showHideDemo1: false });
            if (!this.state.showHideGenerateButton) {
                this.setState({ showHideGenerateButton: !this.state.showHideGenerateButton });
            }
            this.setState({ cyclesPlannedTmt: event.target.value });
        }
        if (event.target.name === 'chemoStartDtTmt') {
            this.setState({ chemoStartDtTmt: event.target.value });
        }
        if (event.target.name === 'additionalConditions') {
            this.setState({ additionalConditions: event.target.value });
        }
        if (event.target.name === 'waiverComments') {
            this.setState({ waiverComments: event.target.value });
        }
        if (event.target.name === 'newTreatment') {
            this.resetSelectedProtocol();
        }
        // if (event.target.name === 'planNo') {
        //     this.setState({ planNo: event.target.value });
        // }
        if (event.target.name === 'planTime') {
            this.setState({ planTime: event.target.value });
        }
    }
    generateSchedule() {
        if (this.checkMandatoryfieldGenerate()) {
            const scheduleIdSelected = parseInt(this.state.scheduleIdTmt);
            // checkMandatoryfieldGenerate already rejects a blank scheduleIdTmt,
            // which is what a protocol with no schedule linked now leaves behind.
            // This guards the remaining case — an id with no matching row — so a
            // stale or retired schedule surfaces as a validation message instead
            // of a crash mid-generation.
            const selectedSchedule = this.state.scheduleMstArr.find(x => x.id === scheduleIdSelected);
            if (!selectedSchedule) {
                this.setState({ treatmentPlanErrors: { scheduleIdTmt: 'Please select Schedule of the Protocol' } });
                return;
            }
            const scheduledDay = selectedSchedule.scheduleDays;
            const chemoStartDt = this.state.chemoStartDtTmt;
            const chemoCycleNum = this.state.cyclesPlannedTmt;
            const isOral = Number(this.state.protocolTypeTmt) === 2;
            const treatmentDays = isOral ? [] : this.parseTreatmentDays(this.state.treatmentDaysTmt);
            console.log('[generateSchedule] treatmentDaysTmt (raw):', this.state.treatmentDaysTmt);
            console.log('[generateSchedule] parsed treatmentDays:', treatmentDays);
            console.log('[generateSchedule] cycles:', chemoCycleNum, '| intervalDays:', scheduledDay, '| startDate:', chemoStartDt, '| isOral:', isOral);
            const generatedScheduledArr = [];

            for (let x = 1; x <= chemoCycleNum; x++) {
                const cycleBaseDate = x === 1
                    ? chemoStartDt
                    : this.addDays(new Date(chemoStartDt.getTime()), (x - 1) * scheduledDay);

                if (treatmentDays.length === 0) {
                    generatedScheduledArr.push({
                        scheduleNum: x,
                        treatmentDayNumber: 1,
                        scheduledDate: cycleBaseDate
                    });
                } else {
                    treatmentDays.forEach(dayNum => {
                        generatedScheduledArr.push({
                            scheduleNum: x,
                            treatmentDayNumber: dayNum,
                            scheduledDate: this.addDays(new Date(cycleBaseDate.getTime()), dayNum - 1)
                        });
                    });
                }
            }
            console.log('[generateSchedule] result (' + generatedScheduledArr.length + ' rows):', generatedScheduledArr.map(r => `C${r.scheduleNum} TD${r.treatmentDayNumber} ${r.scheduledDate}`));
            this.setState({ generatedScheduledArr });
        }
    }
    addTreatmentPlam(event) {
        this.setState({ creationDateTmt: this.formatDateMMDDYY(this.state.creationDateTmt) });
        this.setState({ intentTmt:''});
        this.setState({ adjuvantTmt:''});
        this.setState({ modifiedDateTmt: this.formatDateMMDDYY(this.state.modifiedDateTmt) });
        this.setState({ regProtocolIdTmt:''});
        this.setState({ chemoPhaseRegimenTmt:''});
        this.setState({ scheduleNameTmt:''});
        this.setState({ cyclesPlannedTmt:''});
        this.setState({ dosageFrequency:''});
        this.setState({ treatmentPlanTmt:''});
        this.setState({ additionalConditions:''});
        this.setState({ chemoStartDtTmt: this.formatDateMMDDYY(this.state.chemoStartDtTmt) });
    }
    checkMandatoryfieldGenerate() {
        let errors = [];
        let formIsValid = true;
        if (this.state.scheduleIdTmt === null || this.state.scheduleIdTmt === "" || this.state.scheduleIdTmt === "DEFAULT") {
            errors["scheduleIdTmt"] = "Please select Schedule of the Protocol";
            formIsValid = false;
        }
        if (this.state.cyclesPlannedTmt === null || this.state.cyclesPlannedTmt === "") {
            errors["cyclesPlannedTmt"] = "Please enter Cycles Planned";
            formIsValid = false;
        } else if (Number(this.state.cyclesPlannedTmt) <= 0) {
            errors["cyclesPlannedTmt"] = "Cycles Planned must be greater than 0.";
            formIsValid = false;
        }
        if (this.state.chemoStartDtTmt === null || this.state.chemoStartDtTmt === "") {
            errors["chemoStartDtTmt"] = "Please enter 1st Chemo Cycle";
            formIsValid = false;
        }
        this.setState({ treatmentPlanErrors: errors });
        return formIsValid;
    }
    resetTreatmentPlanData() {
        this.setState({ creationDateTmt: this.formatDateMMDDYY(this.state.creationDateTmt) });
        this.setState({ intentTmt:''});
        this.setState({ adjuvantTmt:''});
        this.setState({ modifiedDateTmt: this.formatDateMMDDYY(this.state.modifiedDateTmt) });
        this.setState({ regProtocolIdTmt:''});
        this.setState({ chemoPhaseRegimenTmt:''});
        this.setState({ scheduleNameTmt:''});
        this.setState({ cyclesPlannedTmt:''});
        this.setState({ dosageFrequency:''});
        this.setState({ treatmentPlanTmt:''});
        this.setState({ additionalConditions:''});
        this.setState({ chemoStartDtTmt:''});
        this.setState({ patTreatPlanIdTmt : ''});
        this.setState({ consentReceived : ''});
        this.setState({ waiverComments : ''});
        this.setState({ consentAttachmentData : ''});
        this.setState({ consentAttachmentName : ''});
        this.setState({ regProtocolNameTmt : ''});
        this.setState({ scheduleIdTmt : ''});
        this.setState({ generatedScheduledArr : []});
        this.setState({ treatmentDaysTmt: '' });
        this.setState({ multiDayCycleTmt: false });
        this.setState({ protocolTypeTmt: '' });
        this.setState({
            //planNo: '',
            treatmentPlanErrors: {}
        });
    }
resetSelectedProtocol = () => {
    this.setState({ selectedProtocol: [], regProtocolIdTmt: '', regProtocolNameTmt: '' });
};

    render() {
        const { showNewTreatment, closeModal, patTreatPlanId, patChemoSittingIdPC, isHospitalStaff, genderName, otherComorbidities, otherAllergies,treatmentPlanSavedSuccess, doctorId, patientAllergies, allergies,formattedAllergies, formattedComorbidities} = this.props;
        const closePreviewModal = () => {
            this.setState({ subErrorMsg: '' });
            this.resetTreatmentPlanData();
            closeModal();
        }
        const {
            context, protocolArr, scheduleMstArr, cancerStageMstArr, isCycleDelay, reportModal, reportMode, showHideDemo1, 
            generatedScheduledArr, appointmentId,treatmentPlanErrors,regProtocolNameTmt,
            selectedApptReportData, redirectCasePage, doctorLoggedIn, regProtocolIdTmt
        } = this.state;
        const displayedComorbidities = otherComorbidities
        ? `${formattedComorbidities ? formattedComorbidities + ', ' : ''}${otherComorbidities}` 
        : formattedComorbidities;
        const displayedAllergies = otherAllergies
        ? `${formattedAllergies ? formattedAllergies + ', ' : ''}${otherAllergies}`
        : formattedAllergies;
        return (
            <Row>
            <Modal id="report" show={showNewTreatment} animation={true} scrollable={true} size="xl">
                <Modal.Header closeButton onClick={() => closePreviewModal()}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Treatment Plan</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <Col lg='9'>
                            <Row>
                                {(() => {
                                    if (patTreatPlanId != 0) {
                                        return (
                                            <Col lg='12' id='contentMsg'>
                                                <Alert variant="danger" show={this.state.alertDismissibleshow} style={{padding: '1.5rem'}} onClick={() => this.setState({ alertDismissibleshow: false })} dismissible>
                                                    <b>Consent is not uploaded. Please upload consent form.</b>
                                                </Alert>
                                            </Col>
                                        )
                                    }
                                })()}
                                <Col lg='12'>
                                <Alert variant="danger" show={this.state.alertDismissibleAllergiesShow} style={{padding: '1.5rem'}} onClick={() => this.setState({ alertDismissibleAllergiesShow: false })} dismissible>
                                    <div><b>Patient Allergies : {displayedAllergies}</b></div>
                                    <div><b>Comorbidities: {displayedComorbidities}</b></div>
                                </Alert>
                               
                                </Col>
                                <Col lg='4'>
                                    <Form.Group>
                                        <Form.Label>Rx Plan Date<span className="text-red"> *</span></Form.Label>
                                        <DatePicker
                                            defaultValue={moment()}
                                            value={moment(this.state.creationDateTmt, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])}
                                            onChange={this.handleTreatPlanChange}
                                            format={dateFormat}
                                            disabled={true}
                                            className="form-control full-width25"
                                        />
                                    </Form.Group>
                                </Col>
                                {this.props.diagnosisDate && (
                                <Col lg='4'>
                                    <Form.Group>
                                        <Form.Label>Date of Diagnosis</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.props.diagnosisDate}
                                            disabled={true}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Intent<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control as="select" id="" name="intentTmt" value={this.state.intentTmt} onChange={this.handleTreatPlanChange}>
                                                        <option value="DEFAULT">- Select Intent -</option>
                                                        <option value="C">Curative</option>
                                                        <option value="P">Palliative</option>
                                                    </Form.Control>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["intentTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Intent</Form.Label>
                                                    <Form.Control as="select" id="" name="intentTmt" value={this.state.intentTmt} onChange={this.handleTreatPlanChange} disabled={true} >
                                                        <option value="DEFAULT">- Select Intent -</option>
                                                        <option value="C">Curative</option>
                                                        <option value="P">Palliative</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Adjuvant<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="" 
                                                        name="adjuvantTmt" 
                                                        value={this.state.adjuvantTmt} 
                                                        onChange={this.handleTreatPlanChange}
                                                    >
                                                        <option value="DEFAULT">- Select Adjuvant -</option>
                                                        <option value="Neo">Neo</option>
                                                        <option value="After">After</option>
                                                    </Form.Control>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["adjuvantTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Adjuvant<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="" 
                                                        name="adjuvantTmt" 
                                                        value={this.state.adjuvantTmt} 
                                                        onChange={this.handleTreatPlanChange} disabled={true}
                                                    >
                                                        <option value="DEFAULT">- Select Adjuvant -</option>
                                                        <option value="Neo">Neo</option>
                                                        <option value="After">After</option>
                                                    </Form.Control>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["adjuvantTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Rx Modification Date<span className="text-red"> *</span></Form.Label>
                                                    <DatePicker value={moment(this.state.modifiedDateTmt, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])} onChange={(date) => date && this.setState({ modifiedDateTmt: date.format('YYYY-MM-DD') })} format={dateFormat} className="form-control full-width25"/>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["modifiedDateTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Rx Modification Date</Form.Label>
                                                    <DatePicker value={moment(this.state.modifiedDateTmt, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])} onChange={this.handleTreatPlanChange} format={dateFormat} disabled={true} className="form-control full-width25"/>
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                                {/* {(() => {
                                // Only show planNo field if user has permission AND
                                // either it's a new treatment plan OR the existing plan has a planNo
                                if (this.state.isRestrictedFieldsVisible && 
                                    (patTreatPlanId == 0 || this.state.planNo)) {
                                    return (
                                        <Col lg='3'>
                                            <Form.Group>
                                                <Form.Label className='mr-3'>Plan Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="planNo"
                                                    value={this.state.planNo || ''}
                                                    onChange={this.handleTreatPlanChange}
                                                    placeholder="Enter Plan No."
                                                    disabled={patTreatPlanId != 0}
                                                />
                                                <div className="invalid-feedback">
                                                    {this.state.treatmentPlanErrors["planNo"]}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    );
                                }
                                return null;
                            })()} */}
                            </Row>
                            <Row>
                                {/* 
                                original code
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Regimen Planned (Protocol Title)<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control as="select" id="" name="regProtocolIdTmt" value={this.state.regProtocolIdTmt} onChange={this.handleTreatPlanChange} >
                                                        <option value="DEFAULT">- Select Regimen Planned -</option>
                                                        {
                                                            protocolArr.map((item, i) => {
                                                                return (
                                                                    <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                );
                                                            })
                                                        }
                                                    </Form.Control>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["regProtocolIdTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Regimen Planned (Protocol Title)</Form.Label>
                                                    <Form.Control as="select" id="" name="regProtocolIdTmt" value={this.state.regProtocolIdTmt} onChange={this.handleTreatPlanChange} disabled={true} >
                                                        <option value="DEFAULT">- Select Regimen Planned -</option>
                                                        {
                                                            protocolArr.map((item, i) => {
                                                                return (
                                                                    <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                );
                                                            })
                                                        }
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()} */}
{(() => {
    if (showNewTreatment && patTreatPlanId == 0) {
        return (
            <Col lg='4'>
                <Form.Group>
                    <Form.Label>Regimen Planned (Protocol Title)<span className="text-red"> *</span></Form.Label>
                    <Select
                        showSearch
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="- Select Regimen Planned -"
                        value={this.state.regProtocolIdTmt || undefined}
                        onChange={(value) => {
                            this.handleTreatPlanChange({ target: { name: 'regProtocolIdTmt', value: value !== undefined ? value : '' } });
                        }}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                        optionFilterProp="children"
                    >
                        {/* Keyed by protocolId, never by name — four protocol names
                            are duplicated in protocol_master (e.g. Cabazitaxel 126
                            and 188), and item.key is a timestamp hash that collides
                            when options are built in the same millisecond. */}
                        {protocolArr.map(item => (
                            <Select.Option key={item.id} value={item.id}>{item.label}</Select.Option>
                        ))}
                    </Select>
                    <div className="invalid-feedback">{treatmentPlanErrors["regProtocolIdTmt"]}</div>
                </Form.Group>
            </Col>
        );
    } else {
        return (
            <Col lg='4'>
                <Form.Group>
                    <Form.Label>Regimen Planned (Protocol Title)</Form.Label>
                    <Form.Control as="select" value={regProtocolNameTmt} disabled={true}>
                        <option>{regProtocolNameTmt}</option>
                    </Form.Control>
                </Form.Group>
            </Col>
        );
    }
})()}
                                <Col lg='4'>
                                    <Form.Group>
                                        <Form.Label>Treatment Days</Form.Label>
                                        <Form.Control type="text" value={this.state.treatmentDaysTmt} disabled={true} />
                                    </Form.Group>
                                </Col>
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Chemotherapy Phase/ Regimen Due<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control as="select" id="" name="chemoPhaseRegimenTmt" value={this.state.chemoPhaseRegimenTmt} onChange={this.handleTreatPlanChange}>
                                                        <option value="DEFAULT">- Select Phase/Regimen Due -</option>
                                                        <option value="Induction">Induction</option>
                                                        <option value="Maintenance">Maintenance</option>
                                                        <option value="Adjuvant">Adjuvant</option>
                                                        <option value="Not applicable">Not applicable</option>
                                                    </Form.Control>
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["chemoPhaseRegimenTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                            
                                        )
                                    } else {
                                        return (
                                            <Col lg='4'>
                                                <Form.Group>
                                                    <Form.Label>Chemotherapy Phase/ Regimen Due</Form.Label>
                                                    <Form.Control as="select" id="" name="chemoPhaseRegimenTmt" value={this.state.chemoPhaseRegimenTmt} onChange={this.handleTreatPlanChange} disabled={true}>
                                                        <option value="DEFAULT">- Select Phase/Regimen Due -</option>
                                                        <option value="Induction">Induction</option>
                                                        <option value="Maintenance">Maintenance</option>
                                                        <option value="Adjuvant">Adjuvant</option>
                                                        <option value="Not applicable">Not applicable</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                                <Col lg='4'>
                                    <Form.Group>
                                        <Form.Label>Schedule for Doctor's Visit<span className="text-red"> *</span></Form.Label>
                                        <Form.Control type='text' id="" name='scheduleNameTmt' value={this.state.scheduleNameTmt} disabled={true} />
                                        {/* <Form.Control as="select" id="" name='scheduleIdTmt' value={this.state.scheduleIdTmt} onChange={this.handleTreatPlanChange} disabled={true}>
                                            <option value="DEFAULT">- Select Schedule of Protocol -</option>
                                            {
                                                scheduleMstArr.map((item, i) => {
                                                    return (
                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                    );
                                                })
                                            }
                                        </Form.Control> */}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg='4'>
                                    {(() => {
                                        if (this.state.activeTreatment == 'N' || isHospitalStaff) {
                                            return (
                                                <Form.Group>
                                                    <Form.Label>Cycles Planned</Form.Label>
                                                    <Form.Control 
                                                        className="form-control full-width25"
                                                        type='number' id="" name='cyclesPlannedTmt'
                                                        value={this.state.cyclesPlannedTmt}
                                                        onChange={this.handleTreatPlanChange}
                                                        disabled={true}
                                                    />
                                                </Form.Group>
                                            )
                                        } else {
                                            return (
                                                <Form.Group>
                                                    <Form.Label>Cycles Planned<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control
                                                        className="form-control full-width25"
                                                        type='number' id="" name='cyclesPlannedTmt'
                                                        value={this.state.cyclesPlannedTmt}
                                                        onChange={this.handleTreatPlanChange}
                                                        min="1"
                                                        disabled={false}
                                                    />
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["chemoStartDtTmt"]}</div>
                                                </Form.Group>
                                            )
                                        }
                                    })()}
                                </Col>

                                <Col lg='4'>
                                    {(() => {
                                        if (this.state.activeTreatment == 'N' || isHospitalStaff) {
                                            return (
                                                <Form.Group>
                                                    <Form.Label>1st Chemo Cycle</Form.Label>
                                                    <DatePicker 
                                                        className="form-control full-width25"
                                                        value={moment(this.state.chemoStartDtTmt, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])} 
                                                        onChange={date => this.setChemoDOB(date._d)}
                                                        format={dateFormat}
                                                        disabled={true}
                                                    />
                                                </Form.Group>
                                            )
                                        } else {
                                            return (
                                                <Form.Group>
                                                    <Form.Label>1st Chemo Cycle<span className="text-red"> *</span></Form.Label>
                                                    <DatePicker 
                                                        className="form-control full-width25"
                                                        value={this.state.chemoStartDtTmt!=''?moment(this.state.chemoStartDtTmt, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']):''}
                                                        onChange={date => this.setChemoDOB(date._d)}
                                                        format={dateFormat}
                                                    />
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["chemoStartDtTmt"]}</div>
                                                </Form.Group>
                                            )
                                        }
                                    })()}
                                </Col>
                                <Col lg='4'>
                                    <Form.Group>
                                        <Form.Label>Dosage Frequency</Form.Label>
                                        <Form.Control type='text' id="" name='dosageFrequency' value={this.state.dosageFrequency} disabled={true}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='pt-2 mt-2'>
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='6'>
                                                <Form.Group>
                                                    <Form.Label>Plan of Treatment<span className="text-red"> *</span></Form.Label>
                                                    <Form.Control as="textarea" placeholder='Enter plan of treatment' name="treatmentPlanTmt" value={this.state.treatmentPlanTmt} rows={3} onChange={this.handleTreatPlanChange} />
                                                    <div className="invalid-feedback">{this.state.treatmentPlanErrors["treatmentPlanTmt"]}</div>
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='6'>
                                                <Form.Group>
                                                    <Form.Label>Plan of Treatment</Form.Label>
                                                    <Form.Control as="textarea" name="treatmentPlanTmt" value={this.state.treatmentPlanTmt} rows={3} onChange={this.handleTreatPlanChange} disabled={true} />
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (patTreatPlanId == 0) {
                                        return (
                                            <Col lg='6'>
                                                <Form.Group>
                                                    <Form.Label>Additional Conditions/ Risks</Form.Label>
                                                    <MicButton label='Additional Conditions/ Risks' long silenceMs={5000} showLangToggle={false} onTranscript={this.appendAdditionalConditions} />
                                                    <Form.Control as="textarea" ref={this.additionalConditionsRef} placeholder='To be specified by doctor' name="additionalConditions" defaultValue={this.state.additionalConditions} rows={3} onChange={this.handleTreatPlanChange} />
                                                </Form.Group>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg='6'>
                                                <Form.Group>
                                                    <Form.Label>Additional Conditions/ Risks</Form.Label>
                                                    <Form.Control as="textarea" name="additionalConditions" defaultValue={this.state.additionalConditions} rows={3} onChange={this.handleTreatPlanChange} disabled={true} />
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                            </Row>
                            <Row>
                                {(() => {
                                    if (patTreatPlanId != 0 && this.state.consentReceived == 'Y' && this.state.consentAttachmentName) {
                                        return (
                                            <Col lg='4'>
                                                <Form.Label>Attached Consent:</Form.Label>
                                                <div>
                                                    <a download={this.state.consentAttachmentName} href={this.state.consentAttachmentData}>{this.state.consentAttachmentName}</a>
                                                </div>
                                            </Col>
                                        )      
                                    }else if(patTreatPlanId != 0 && this.state.consentReceived == 'Y'){
                                        return (
                                            <Col lg='6'>
                                                <Form.Group>
                                                    <Form.Label>Consent waive Off comment:</Form.Label>
                                                    <Form.Control as="textarea" name="treatmentPlanTmt" defaultValue={this.state.waiverComments} rows={3} disabled={true} />
                                                </Form.Group>
                                            </Col>
                                        )
                                    }
                                })()}
                            </Row>
                        </Col>
                        {/* <Col lg='1' style={{ maxWidth: '3%' }}></Col> */}
                        <Col lg='3'>
                            {
                                (showHideDemo1) ?
                                <Row>
                                    <Col lg='12'>
                                        <table id="" className="table table-striped table-hover text-center generateSchedule" role="grid">
                                            <thead className="thead-light">
                                                <tr role="row">
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Cycle</th>
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Day</th>
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Doctor's Visit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {typeof generatedScheduledArr !== 'undefined' &&
                                                    generatedScheduledArr
                                                    .sort((a, b) => (a.scheduleNum - b.scheduleNum) || (a.treatmentDayNumber - b.treatmentDayNumber))
                                                    .map((d, idx) => (
                                                        <tr key={idx} role="row" className="odd">
                                                            <td>{d.scheduleNum}</td>
                                                            <td>{(this.state.treatmentDaysTmt && Number(this.state.protocolTypeTmt) !== 2) ? d.treatmentDayNumber : ''}</td>
                                                            <td><DatePicker value={moment(d.scheduledDate, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])} format={dateFormat} bordered={false} suffixIcon={null} disabled/></td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row> :
                                <Row>
                                    <Col lg='12'>
                                        <table id="" className="table table-striped table-hover text-center generateSchedule" role="grid" >
                                            <thead className="thead-light">
                                                <tr role="row">
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Cycle</th>
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Day</th>
                                                    <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemotherapy Schedule</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {typeof generatedScheduledArr !== 'undefined' &&
                                                    generatedScheduledArr
                                                    .sort((a, b) => (a.scheduleNum - b.scheduleNum) || (a.treatmentDayNumber - b.treatmentDayNumber))
                                                    .map((d, idx) => (
                                                        <tr key={idx} role="row" className="odd">
                                                            <td>{d.scheduleNum}</td>
                                                            <td>{(this.state.treatmentDaysTmt && Number(this.state.protocolTypeTmt) !== 2) ? d.treatmentDayNumber : ''}</td>
                                                            <td><DatePicker value={moment(d.scheduledDate, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])} format={dateFormat} bordered={false} suffixIcon={null} disabled/></td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                    <Col lg='12'>
                            {this.state.subErrorMsg && (
                                <Alert variant="danger" className="mb-2" onClose={() => this.setState({ subErrorMsg: '' })} dismissible>
                                    {this.state.subErrorMsg}
                                </Alert>
                            )}
                            {
                                (showHideDemo1) ?
                                <Row>
                                    <Col lg='12' className="form-button text-center mt-2">
                                        <Button type="button" variant="secondary" className="btn mr-2" onClick={this.submitTreateMentPlan.bind(this)}>
                                            {this.state.saveLoader && (
                                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                                            )}
                                            Save
                                        </Button>
                                        {(() => {
                                            if (this.state.showHideGenerateButton) {
                                                return (
                                                    <Button variant="secondary" className="btn mr-2" onClick={() => this.hideComponent("showHideDemo1")}>Generate Schedule</Button>
                                                )
                                            }
                                        })()}
                                        <Button className="btn btn-info mr-1" onClick={() => closePreviewModal()}> Cancel </Button>
                                    </Col>
                                </Row> :
                                <Row>
                                    <Col lg='12' className='text-center'>
                                        {/* <Button variant="secondary" className="btn mr-2" onClick={this.addTreatmentPlam.bind(this)}>Save</Button> */}
                                        {(() => {
                                            if (this.state.showHideGenerateButton) {
                                                return (
                                                    <Button variant="secondary" className="btn mr-2" onClick={() => this.hideComponent("showHideDemo1")}>Generate Schedule</Button>
                                                )
                                            }
                                        })()}
                                        <Button className="btn btn-info mr-2" onClick={() => closePreviewModal()}> Cancel </Button>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>


                                            
        </Row>
            
        )
    }
}